<template>
  <v-snackbar v-model="show" :color="color" :timeout="timeout" class="infomsg">
    <v-card class="mx-auto">
      <v-card-title>
        {{title}}
      </v-card-title>
      <v-card-text>
        {{message}}
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="show = false">{{$t('ERROR_CLOSE')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      title: '',
      message: '',
      color: '',
      timeout: 2000000,
    }
  },

  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showMessage') {
        this.title = state.msg.title
        this.message = state.msg.content
        this.color = state.msg.color
        this.show = true
      }
    })
  }
}
</script>

<style>
  .infomsg .v-snack__wrapper {
    max-width: 800px;
  }

</style>